import { Row } from "@tanstack/react-table";

export type RowHandlers = Pick<
	React.HTMLAttributes<HTMLTableRowElement>,
	"onClick" | "onAuxClick" | "onKeyDown" | "tabIndex"
>;

export const INTERACTIVE_SEL = [
	"a[href]",
	"button",
	"input",
	"select",
	"textarea",
	"summary",
	"[role='dialog']",
	"[role='button']",
	"[role='tab']",
	"[role='option']",
	"[role='link']",
	"[role='menuitem']",
	"[contenteditable='true']",
	"[data-interactive]",
].join(",");

const isInteractive = (t: Element | null) => !!t?.closest(INTERACTIVE_SEL);
const hasSelection = () => {
	const s = window.getSelection?.();
	return !!s && s.type === "Range" && s.toString().length > 0;
};

/** Sensible default: click/Enter toggles; ignores links, interactive, modifiers, selection. */
export function defaultExpandHandlers<T>(row: Row<T>): RowHandlers {
	return {
		onClick: (e) => {
			if (e.defaultPrevented) {
				return;
			}
			const t = e.target as Element;
			if (isInteractive(t) || t.closest("a[href]")) {
				return;
			}
			if (hasSelection()) {
				return;
			}
			if (e.metaKey || e.ctrlKey || e.button !== 0) {
				return;
			}
			row.toggleExpanded();
		},
		onKeyDown: (e) => {
			if (e.defaultPrevented) {
				return;
			}
			if (e.key === "Enter" && !(e.metaKey || e.ctrlKey)) {
				if (isInteractive(e.target as Element)) {
					return;
				}
				row.toggleExpanded();
			}
		},
	};
}
